export default __webpack_public_path__ + "static/Earth-Day-Homepage-Banner-Desktop-523c55106088f04acce66d38f65c1935.webp";